import { render, staticRenderFns } from "./amazonAudit.vue?vue&type=template&id=2dffdba5&"
import script from "./amazonAudit.vue?vue&type=script&lang=js&"
export * from "./amazonAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports